import capitalize from "lodash/capitalize";
import { MediaAxios } from "../axios/media/media.axios";
import { ThemeKeys } from "../ThemeContext";
import { ChatWidgetCurrent } from "../model/chat-wiget/types/ChatWigetCurrent.enum";
import { Images } from "../assets";
import { MetaMessageLoadImageDto } from "../model/integration/dto/meta/MetaMessageLoadImage";
import { TestIDs } from "../tests/types/testIds";
import { IntegrationAxios } from "../axios/integration/integration.axios";

export function getMediaUrl(
  mediaId: string,
  query?: Record<string, string | number | boolean | undefined>,
): string {
  return MediaAxios.getImageUrl(mediaId, query);
}

export const getChatImage = (
  selectedTheme: ThemeKeys,
  menuOpen: boolean,
  current: ChatWidgetCurrent | null,
) => {
  const currentTheme = capitalize(
    (selectedTheme as any) === "light" ? ThemeKeys.PURPLE : selectedTheme,
  );

  if (!menuOpen) {
    return {
      image: Images[`ChatClosedIcon${currentTheme}` as keyof typeof Images],
      className: TestIDs.fahmy.image("closed"),
    };
  }

  if (current === ChatWidgetCurrent.CHAT) {
    return {
      image: Images[`ChatChattingIcon${currentTheme}` as keyof typeof Images],
      className: TestIDs.fahmy.image("chatting"),
    };
  }

  return {
    image: Images[`ChatOpenIcon${currentTheme}` as keyof typeof Images],
    className: TestIDs.fahmy.image("open"),
  };
};

export const getMetaChatMedia = (dto: MetaMessageLoadImageDto) => {
  return IntegrationAxios.getMetaChatMedia(dto);
};
